// @unocss-include
import { resourcesLinks, type ResourceLink } from './resources-links';
import { socialLinks } from './socialLinks';
import type { NavigationItem } from '~/components/header/NavigationItem';
import { ResourcesDropdown, MobileResourcesDropdown } from '~/components/header/ResourcesDropdown';
import { DISCORD, ENTERPRISE, CAREERS_URL, PRICING_URL } from '~/lib/urls';

export const resourcesAndSocialLinks: Omit<ResourceLink, 'shortName'>[] = [
  ...resourcesLinks,
  ...socialLinks.map((link) => ({ ...link, openInNewTab: true })),
];

const WrappedResourcesDropdown = ({ className }: { className?: string }) => (
  <ResourcesDropdown className={className} activeClass="text-bolt-ds-textPrimary" />
);

const WrappedMobileResourcesDropdown = ({ className }: { className?: string }) => (
  <MobileResourcesDropdown className={className} />
);

export const getNavItemsMeta = (): NavigationItem[] => [
  {
    type: 'link',
    label: 'Community',
    href: DISCORD,
    target: '_blank',
  },
  {
    type: 'link',
    label: 'Enterprise',
    href: ENTERPRISE,
    target: '_blank',
  },
  {
    type: 'component',
    component: WrappedResourcesDropdown,
    desktopOnly: true,
  },
  {
    type: 'link',
    label: 'Careers',
    href: CAREERS_URL,
    target: '_blank',
  },
  {
    type: 'link',
    label: 'Pricing',
    href: PRICING_URL,
  },
  {
    type: 'component',
    component: WrappedMobileResourcesDropdown,
    mobileOnly: true,
  },
];
